

export default function (capitalizeFirstLetter = false, capitalizeBothWords = false) {
    let result;

    if (process.env.VUE_APP_REGION === 'US') {
        result = 'pharmacy professional';
    } else {
        // result = 'locum';
        result = 'pharmacy professional';
    }

    // Capitalization logic for "pharmacy professional"
    if (result === 'pharmacy professional') {
        if (capitalizeBothWords) {
            // Capitalize both words: "Pharmacy Professional"
            result = 'Pharmacy Professional'; // Directly set to the capitalized version
        } else if (capitalizeFirstLetter) {
            // Capitalize first word only: "Pharmacy professional"
            result = result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
        }
    }

    // Handle capitalization for 'locum'
    if (capitalizeFirstLetter && result === 'locum') {
        result = result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
    }

    return result;
}

